/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

const mutations = {
  auth_request (state) {
    state.status = 'loading'
  },
  auth_success (state, {token, user, userRole ,licenseAgreed=false}) {
    
    state.status = 'success'
    state.token = token
    state.user = user
    state.userRole = userRole;
    state.licenseAgreed = licenseAgreed;
   // alert(JSON.stringify(state.user));
    
  },
  updateUserState(state ,user){
    state.user = user
  },
  license_agree(state,{licenseAgreed=false} ){
    state.licenseAgreed = licenseAgreed;

  },
  logOut(state){
    state.status = ''
    state.token = null
    state.user = null
    state.userRole = null;

  },
  setViewAsCustomer(state ,data){
    state.ViewAsCustomer = data;
    localStorage.setItem("ViewAsCustomer" ,JSON.stringify( data) );

   

  },
  setAdminUser(state ,data){
    state.adminUser = data;
    localStorage.setItem("adminUser" ,JSON.stringify( data) );
    

  }
}

export default mutations
